import { bridge } from "@multiweb/reactCore/bridge";
import { DEFAULT_ACTIVITY_LEFT, DEFAULT_ACTIVITY_TOP, HEIGHT_OF_WF_SET, WIDTH_OF_WF_SET } from "./constants";

const { loadLocalizationItems } = bridge;

/**
 * Vrací umístění nově přidané aktivity v závislosti na stavu plátna picassa.
 * Stará se o to, aby souřadnice aktivity byly takové, aby se aktivita přidala ve viditelné části plátna.
 * Tedy že nebude schovaná nebo že nebude mimo hranici sady.
 */
export const getActivityNewPosition = (xOffset: number, yOffset: number, scaleIndex: number) => {
    let newX = (DEFAULT_ACTIVITY_LEFT + xOffset) / scaleIndex;
    let newY = (DEFAULT_ACTIVITY_TOP + yOffset) / scaleIndex;

    if (newX < DEFAULT_ACTIVITY_LEFT)
        newX = DEFAULT_ACTIVITY_LEFT;

    if (newY < DEFAULT_ACTIVITY_TOP)
        newY = DEFAULT_ACTIVITY_TOP;

    if (newX > WIDTH_OF_WF_SET)
        newX = WIDTH_OF_WF_SET - 100;

    if (newY > HEIGHT_OF_WF_SET)
        newY = HEIGHT_OF_WF_SET - 100;

    return {
        x: Math.round(newX / 10) * 10,
        y: Math.round(newY / 10) * 10,
    };
};

/**
 * Sestavuje error zprávu na základě poskytnuté šablony, názvu třídy a názvu atributu.
 * @param attrNameLocKey Název nevyplněného povinného atributu.
 * @param instanceNameLocKey Název třídy, kde došlo k nevalidnosti.
 * @param templateLocKey Lokalizovaná šablona zprávy.
 */
export const getErrorMessage = async (attrNameLocKey: string, instanceNameLocKey: string, templateLocKey: string) => {
    const locItems = await loadLocalizationItems([attrNameLocKey, instanceNameLocKey, templateLocKey]);

    const messageTemplate = locItems.get(templateLocKey)?.primaryText ?? "";
    const attrName = locItems.get(attrNameLocKey)?.primaryText ?? "";
    const instanceName = locItems.get(instanceNameLocKey)?.primaryText ?? "";

    return stringFormat(messageTemplate, attrName, instanceName);
};

/** Funkce funguje identicky jako C# string.Format */
export const stringFormat = (str: string, ...args: string[]) => str.replace(/{(\d+)}/g, (_match, index) => args[index] || "");
